import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GlobalNavMenuActions, GlobalNavService } from '../../core-ui';
import { InitDataService } from '../../system-services';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    openCreateTeamPeek$ = new BehaviorSubject<boolean>(false);

    constructor(
        private navService: GlobalNavService,
        private initData: InitDataService
    ) {}

    /**
     * Navigates to the specified module on Dashboard card click
     *
     * @param module
     */
    async navigate(module: GlobalNavMenuActions) {
        await this.navService.menuAction(module);
    }
    /**
     * Gets the active status of a given module
     *
     * @param module
     * @returns UserAccessLevelMap for given module
     */
    getModuleStatus(module: GlobalNavMenuActions) {
        return this.initData.userAccessLevelMap.get(module);
    }
}
